// removed by extract-text-webpack-plugin
module.exports = {"loginPageWrap":"qempo_LoginPage_loginPageWrap-2SVbxpN","loginWrap":"qempo_LoginPage_loginWrap-3DDFxbp"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/components/Login/LoginPage.scss
// module id = 1228
// module chunks = 0